import LomdaV2Thumbnail from "@/features/lomdaEditorV2/utils/lomdaV2Thumbnail";
import { GetLomdaV2ResponseType } from "../hooks/useGetLomdaV2";
import GeneralTab from "./tabs/general";
import {
    LomdaContent,
    LomdaMetadata,
} from "@/features/lomdaEditorV2/lib/lomdaTypes";

export default function LomdaV2SheetMain({
    lomda,
}: {
    lomda: GetLomdaV2ResponseType["data"];
}) {
    const content = lomda?.content
        ? (JSON.parse(lomda.content) as LomdaContent)
        : null;
    const metadata = lomda?.metadata
        ? (JSON.parse(lomda.metadata) as LomdaMetadata)
        : null;

    return (
        <main className="flex flex-1 flex-col py-4 px-8 gap-4">
            <div className="relative aspect-video rounded-md border overflow-hidden">
                <LomdaV2Thumbnail
                    content={content}
                    metadata={metadata}
                    lomdaId={lomda.id}
                    lomdaName={lomda.name || ""}
                    userId={lomda.userId}
                />
            </div>
            <GeneralTab lomda={lomda} />
            <div className="pb-8" />
        </main>
    );
}
